export class UserConfig {
  public static EndPoint = {
    User: {
      getAllUserList: '/org/user',
      getAllUserActiveInactive: '/org/user?includeInactiveUsers=true',
      getUserConfig: '/org/user/getUserPreference/USER_THEME_PREFERENCES/{id}',
      activateUser: '/org/user/activate',
      createUser: '/org/user/create',
      userRole: '/org/user/role',
      managementgroup: '/org/team/managementgroup',
      getAllUserOrgList: '/org/user/organization/',
      saveUserConfig: '/org/user/saveUserPreference'
    },
    Provider: {
      getProviderList: '/ref/provider',
      searchProviderList: '/ref/provider/search',
      addProviderUser: '/ref/provider/create/account'
    }
  };
}
